<template>
  <div class="yujihua">
    <PublicScore :logo="Logo1" :type="'acet'" :color="'#f08608'" />
  </div>
</template>

<script>
import PublicScore from '../component/scoreQuery.vue'
import Logo1 from '@/assets/images/logo1.png'

export default {
  name: 'YuJiHua',
  components: {
    PublicScore
  },
  data() {
    return {
      Logo1
    }
  }
}
</script>
